export const alloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbed =
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/app_embed";
